import { API, Auth } from 'aws-amplify';

import awsConfig from '@config/aws';

API.configure(awsConfig);

const updateList = (apiKey, updatedList, callback) => {
  putData(apiKey, 'ScreenConsoleApi', `list`, [updatedList], callback);
};

const putData = async (apiKey, apiName, path, body, callback) => {
  const requestConfig = {
    body,
    headers: {
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
      'x-api-key': apiKey,
    },
  };
  API.put(apiName, path, requestConfig)
    .then(response => {
      callback(response);
    })
    .catch(error => {
      console.error('Error with API:', error);
    });
};

export default updateList;
